import store from 'public/store'
import router from '../router'
import bus from 'public/utils/bus'
import MENUSTYLE from './menu-style'
import { QtReportOpenModuleByLeftMenu } from '@/layout/utils/report-qt.js'

// 财务成本管理详情
const HideMenus = ['152995231408803407']

function filterTree (tree) {
  try {
    if (!Array.isArray(tree)) {
      return tree
    }
    return tree.filter(function(item) {
      return !HideMenus.includes(item.id)
    })
  } catch (e) {
    console.error('【layout-menu:filterTree】', e)
    return tree
  }
}


class KYEMenu extends HTMLElement {
  constructor () {
    super()
    this.attachShadow({ mode: 'open' })
    this.bindActiveMenu = this.delayActiveMenu.bind(this)
    this.bindCollapseMenu = this.collapseMenu.bind(this)
    this.bindRemindMenu = this.remindMenu.bind(this)
    this.bindOpenMenu = this.openMenu.bind(this)
    this.bindSetTheme = this.setTheme.bind(this)
    bus.$on('TAB_CLICK', this.bindActiveMenu)
    bus.$on('SWITCH_MENU', this.bindCollapseMenu)
    bus.$on('SET_MENUS_REMIND', this.bindRemindMenu)
    bus.$on('GLOBAL_MENU_OPEN', this.bindOpenMenu)
    bus.$on('SET_THEME', this.bindSetTheme)
    bus.$on('APP_LOADED', this.render.bind(this))
  }

  disconnectedCallback () {
    bus.$off('TAB_CLICK', this.bindActiveMenu)
    bus.$off('SWITCH_MENU', this.bindCollapseMenu)
    bus.$off('SET_MENUS_REMIND', this.bindRemindMenu)
    bus.$off('GLOBAL_MENU_OPEN', this.bindOpenMenu)
    bus.$off('SET_THEME', this.bindSetTheme)
  }

  get sync () {
    return this.getAttribute('sync') === 'true'
  }

  setTheme (obj, type) {
    if (!type || type === 'menu') {
      // 暂存参数，延迟到菜单 render 后执行
      if (!this.rootDom) {
        this.setThemeArgs = [obj, type]
        return
      }
      // let src = this.svgDoms[0].src
      if (obj.menu === 'dark') {
        this.rootDom.classList.add('level1_dark')
        // if (!src.endsWith('_dark.svg')) {
        //   this.svgDoms.forEach(v => v.src = v.src.replace('.svg', '_dark.svg'))
        // }
      } else {
        this.rootDom.classList.remove('level1_dark')
        // if (src.endsWith('_dark.svg')) {
        //   this.svgDoms.forEach(v => v.src = v.src.replace('_dark', ''))
        // }
      }
    }
  }

  collapseMenu (width, isCollapse) {
    if (isCollapse) {
      this.min()
    } else {
      this.max()
    }
  }

  remindMenu () {
    const menus = store.state.remindMenus || {}
    const shows = []
    const removes = []
    Object.keys(menus).forEach(v => {
      if (menus[v]) {
        shows.push(v)
      } else {
        removes.push(v)
      }
    })
    removes.forEach(this.removeMark.bind(this))
    shows.forEach(this.showMark.bind(this))
  }

  openMenu ({ tag }) {
    if (this.activeTag && tag !== this.activeTag) {
      this.delayActiveMenu(window.location.hash.substr(1), tag)
    }
  }

  delayActiveMenu (path, tag, keep) {
    setTimeout(_ => {
      this.activeMenu(path, tag, keep)
    }, 300)
  }

  activeMenu (path, tag, keep) {
    if (!this.sync || !path) return
    if (keep) {
      this.menuDoms.forEach(this.removeActive)
      return
    }
    tag = tag || router.resolve(path).route.meta.tag
    this.activeTag = tag
    tag = tag && store.getters.menus[tag]
    if (!tag) return
    let { id, parentId, title, $ptitle } = tag
    let inputTop = this.shadowRoot.querySelector(`#${$ptitle}`)
    if (parentId) {
      // 3级菜单
      let input = this.shadowRoot.querySelector(`#id${parentId}`)
      if (!input || !inputTop) return
      inputTop.checked = true
      input.checked = true
      let clickEvent = new CustomEvent('autoClick', { detail: { input, inputTop } })
      this.rootDom.dispatchEvent(clickEvent)
      this.menuDoms.forEach(this.removeActive)
      this.shadowRoot.querySelector(`#id${id}`).classList.add('active')
      this.addActiveLink($ptitle)
    } else if (inputTop) {
      this.menuDoms.forEach(this.removeActive)
      let a = this.shadowRoot.querySelector(`#id${id}+a`)
      if (a) {
        // 2级菜单
        inputTop.checked = true
        let clickEvent = new CustomEvent('autoClick', { detail: { inputTop } })
        this.rootDom.dispatchEvent(clickEvent)
        a.classList.add('active')
        this.addActiveLink($ptitle)
      } else {
        // 1级菜单
        this.shadowRoot.querySelector(`#${title}+a`).classList.add('active')
        this.addActiveLink(title)
      }
    }
  }

  setRoute (tag) {
    if (!tag) return
    let view = store.state.tagsView.visitedViews.find(v => v.tag === tag)
    let path = view && view.path !== tag ? view.path : tag
    const route = router.resolve(path).route
    route.meta.layout = true
    bus.$emit('GLOBAL_USE_OPEN_MODULE', route.meta.tag || tag)
    window.location.hash = '#' + path
    // 从框架布局进入，添加入口标记
    bus.$emit('TAB_CLICK', path, tag)
  }

  removeActive (dom) {
    if (dom.classList.contains('active')) {
      dom.classList.remove('active')
    }
  }

  addActiveLink (title) {
    // 一级菜单反白处理
    let temp = this.shadowRoot.querySelector('.activelink')
    if (temp) {
      temp.classList.remove('activelink')
    }
    this.shadowRoot.querySelector(`#${title}+a`).classList.add('activelink')
  }

  min () {
    this.rootDom.classList.add('min-size')
  }

  max () {
    this.rootDom.classList.remove('min-size')
  }

  removeMark (path) {
    let { id, parentId, $ptitle } = store.getters.menus[path] || {}
    if (parentId) {
      let dom = this.shadowRoot.querySelector(`#id${id}`)
      dom && dom.classList.remove('mark')
      dom = this.shadowRoot.querySelector(`#label${parentId}`)
      dom && dom.classList.remove('mark')
    } else {
      let dom = this.shadowRoot.querySelector(`#label${id}`)
      dom && dom.classList.remove('mark')
    }
    let dom = this.shadowRoot.querySelector(`#label${$ptitle}`)
    dom && dom.classList.remove('mark')
  }

  showMark (path) {
    let { id, parentId, $ptitle } = store.getters.menus[path] || {}
    if (parentId) {
      let dom = this.shadowRoot.querySelector(`#id${id}`)
      dom && dom.classList.add('mark')
      dom = this.shadowRoot.querySelector(`#label${parentId}`)
      dom && dom.classList.add('mark')
    } else {
      let dom = this.shadowRoot.querySelector(`#label${id}`)
      dom && dom.classList.add('mark')
    }
    let dom = this.shadowRoot.querySelector(`#label${$ptitle}`)
    dom && dom.classList.add('mark')
  }

  initEvent () {
    if (this.getAttribute('unique-opened') !== 'true') return
    let self = this
    this.rootDom.addEventListener('click', function (e) {
      let type = e.target.nodeName
      if (type === 'INPUT') {
        self.handelClick(e.target)
      } else if (type === 'A') {
        e.preventDefault()
        self.setRoute(e.target.hash.substr(1))
        QtReportOpenModuleByLeftMenu(e.target.hash.substr(1))
      } else if (type === 'LABEL') {
        let path = e.target.getAttribute('path')
        if (path) {
          self.setRoute(path)
          QtReportOpenModuleByLeftMenu(path)
        }
      }
    })

    this.rootDom.addEventListener('autoClick', function (e) {
      let { input, inputTop } = e.detail
      if (input) {
        self.handelClick(input)
      }
      if (inputTop) {
        self.handelClick(inputTop)
      }
    })
  }

  handelClick (target) {
    if (target.name === 'level1') {
      this.level1InputDoms.forEach(input => {
        if (input !== target) input.checked = false
      })
    } else {
      this.level2InputDoms.forEach(input => {
        if (input !== target) input.checked = false
      })
    }
  }
  // 当前菜单icon
  getMenuIconUrl (menu, isActive) {
    const { menuCode, subSystem } = menu
    let str = subSystem.toLowerCase().replace(/,/g, '')
    const iconClass = isActive ? 'light' : 'gray'
    // 首页
    if (menuCode === '/') {
      str = 'home'
    }
    return `layout layout-module-${str}-${iconClass}`
  }

  renderLevel2 (subTree) {
    return '<ul style="display:none" class="level2">' + subTree.map(menu => `
              <li>
                <input class="level2input" type="checkbox" name="level2" id="id${menu.id}" style="display: none" />
                <a class="${menu.children ? 'tri-down' : 'menu'}" href="#${menu.children ? '' : menu.menuCode}">
                  <label id="label${menu.id}" ${menu.children ? `for="id${menu.id}"` : `path="${menu.menuCode}"`}>${menu.label}</label>
                </a>
                ${menu.children ? this.renderLevel3(menu.children) : ''}
              </li>
        `).join('') + '</ul>'
  }

  renderLevel3 (originSubTree) {
    const subTree = filterTree(originSubTree)
    return '<ul style="display:none" class="level3">' + subTree.map(menu => `
              <li>
                <a class="menu" id="id${menu.id}" href="#${menu.menuCode}">${menu.label}</a>
              </li>
        `).join('') + '</ul>'
  }

  render () {
    let menuTree = store.getters.menus.menuTree
    this.shadowRoot.innerHTML = `
      <link rel="stylesheet" href="//iconfont.kye-erp.com/t/c/font_1140206_swt70dh0kz.css">
      <style>${MENUSTYLE}</style>
      <ul class="level1">
        ${menuTree.map(menu => `
          <li>
            <input class="level1input" type="checkbox" name="level1" id="${menu.label}" style="display: none" />
            <a
              class="${menu.children ? `tri-down` : 'menu'}"
              href="#${menu.menuCode || ''}"
              ${menu.tips ? `title="${menu.tips}"` : ''}>
              <label id="label${menu.label}" class="root-menu" ${menu.children ? `for="${menu.label}"` : `path="${menu.menuCode}"`}>
                <i class="${this.getMenuIconUrl(menu)}"></i>
                <i class="${this.getMenuIconUrl(menu, true)}"  style="display: none"></i>
                ${menu.label}
              </label>
            </a>
            ${menu.children ? this.renderLevel2(menu.children) : ''}
          </li>
      `).join('')}
      </ul>
    `
    this.rootDom = this.shadowRoot.querySelector('.level1')
    this.menuDoms = [...this.shadowRoot.querySelectorAll('.level1 a.menu')]
    this.level2InputDoms = [...this.shadowRoot.querySelectorAll('.level2 .level2input')]
    this.level1InputDoms = [...this.shadowRoot.querySelectorAll('.level1 .level1input')]
    // this.svgDoms = [...this.shadowRoot.querySelectorAll('img')]
    this.initEvent()
    this.setRoute(window.location.hash.substr(1))
    if (this.setThemeArgs) {
      this.setTheme(...this.setThemeArgs)
      // this.setThemeArgs = null
    }
  }
}

window.customElements.define('kye-menu', KYEMenu)



// WEBPACK FOOTER //
// ./src/layout/layout/menu.js